import { render, staticRenderFns } from "./ProblemTaskEdit.vue?vue&type=template&id=32b87b44"
import script from "./ProblemTaskEdit.vue?vue&type=script&lang=js"
export * from "./ProblemTaskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports